export class MasSendEntity{
    id:number;
    message:string;
    mailId:number;
    mail:string;
    creationDate:string;
    creationUserId:number;
    creationUser:string;
    approvalDate:string;
    approvalUserId:number;
    approvalUser:string;
    sendingDate:string;
    sendingUserId:number;
    sendingUser:string;

    constructor(){}
}